module.exports = __webpack_public_path__ + "img/326.35be4132.png";